import loading from './index.vue';
import Vue from 'vue';

let instance = null;

let LoadingConstructor = Vue.extend(loading);

const initInstance = () => {
  instance = new LoadingConstructor({
    el: document.createElement('div') // 将组件挂载到新创建的div上
  })
  document.body.appendChild(instance.$el); // 将组件的dom添加到body里
}

let startLoading = () => {
  if (!instance) {
    initInstance();
  }
  instance.visible = true;
} 
let closeLoading = () => {
  if (!instance) {
    initInstance();
  }
  instance.visible = false;
} 

Vue.prototype.$startLoading = startLoading;
Vue.prototype.$closeLoading = closeLoading;
